<nz-spin [nzSpinning]="isLoading">
    <div class="container">
        <div class="page-header">
            <div>
                <p class="eyebrow">Dispositions</p>
                <h2>Disposition Control</h2>
                <p class="subtitle">Change the status of dispositions</p>
            </div>
            <div class="header-actions">
                <button nz-button nzShape="round" nzType="default" (click)="getData()" [disabled]="isLoading">
                    <i nz-icon nzType="reload"></i>
                    Refresh
                </button>
            </div>
        </div>

        <div class="filter-card">
            <div class="filter-group">
                <label>Provider</label>
                <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Select a Provider" [(ngModel)]="selectedProvider"
                    (ngModelChange)="getData()">
                    <nz-option *ngFor="let p of availableProviders" [nzValue]="p.id" [nzLabel]="p.name"></nz-option>
                </nz-select>
            </div>
            <div class="filter-actions">
            </div>
        </div>

        <nz-table #basicTable [nzData]="dispositions" [nzFrontPagination]="false" [nzTotal]="total" nzBordered
            [nzPageSize]="pageSize" [nzPageIndex]="pageIndex">
            <thead>
                <tr>
                    <th nzWidth="60%">Disposition Name</th>
                    <th nzWidth="20%">Status</th>
                    <th nzWidth="20%">Action</th>
                </tr>
            </thead>

            <tbody>
                <tr *ngFor="let disp of dispositions">
                    <td>{{ disp.disposition }}</td>

                    <td>
                        <nz-tag [nzColor]="disp.da_status === 'active' ? 'green' : 'red'">
                            {{ disp.da_status | titlecase }}
                        </nz-tag>
                    </td>

                    <td>
                        <nz-switch [ngModel]="disp.da_status === 'active'" [nzControl]="true"
                            (click)="toggleDisposition(disp)">
                        </nz-switch>
                    </td>
                </tr>
            </tbody>
        </nz-table>
    </div>
</nz-spin>
